/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type PaymentApiResourceType = typeof PaymentApiResourceType[keyof typeof PaymentApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentApiResourceType = {
  booking: 'booking',
  pet_fee: 'pet_fee',
  other: 'other',
  rent: 'rent',
  refund: 'refund',
  hospitality_management_fee: 'hospitality_management_fee',
} as const;
